import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC } from "react";

import { EmphasisSlider } from "../../sliders/emphasis-slider";
import { EmphasisSliderSectionVariants } from "./types";

export interface EmphasisSliderSectionProps extends Queries.EmphasisSliderSectionDataFragment {}

export const EmphasisSliderSection: FC<EmphasisSliderSectionProps> = ({
  title,
  description,
  slides,
  variant = EmphasisSliderSectionVariants.INTERNAL,
}) => {
  const isPrimaryVariant =
    variant === EmphasisSliderSectionVariants.INTERNAL ||
    variant === EmphasisSliderSectionVariants.EXTERNAL;

  return (
    <div
      className={clsx([
        "flex flex-col w-full py-16 lg:py-28 gap-5 items-center",
        isPrimaryVariant && "bg-primary",
        !isPrimaryVariant && "bg-light",
      ])}
    >
      <div
        className={clsx([
          "text-center text-3xl lg:text-4xl leading-tight font-medium px-8 lg:px-20 max-w-4xl",
          !isPrimaryVariant && "text-primary",
          isPrimaryVariant && "text-light",
        ])}
      >
        {title}
      </div>
      <div
        className={clsx([
          "text-lg leading-snug font-light px-8 lg:px-20 max-w-4xl text-center",
          !isPrimaryVariant && "text-dark",
          isPrimaryVariant && "text-light",
        ])}
      >
        {description?.text}
      </div>
      <EmphasisSlider slides={slides} variant={variant} className="mt-14 hidden xl:flex" />
      <EmphasisSlider slides={slides} variant={variant} className="mt-14 flex xl:hidden" isMobile />
    </div>
  );
};

export const query = graphql`
  fragment EmphasisSliderSectionData on ContentfulEmphasisSliderSection {
    __typename
    title
    variant
    description {
      text: description
    }
    slides {
      ...HorizontalCardData
    }
  }
`;
